import React from 'react';
import { Box, Card, Divider, TableBody } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Paginator from "../../toolkit/Paginator";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import axios from '../../utils/fvAxios';
import { ToastContainer, toast } from 'react-toastify';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import "../../pages/newregisteration/newregisteration.css";

export default function SearchUserNames() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));

    const navigate = useNavigate();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));


    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };


    const [AllLanguage, setAllLanguage] = React.useState([]);
    const [languageId, setLanguageId] = React.useState("");
    const [SearchUserNames, setSearchUserNames] = React.useState([]);
    const [Status, setStatus] = React.useState("");
    const [Name, setName] = React.useState("");
    const [BiddId, setBiddId] = React.useState("");
    const [Count, setCount] = useState("");
    const [number, setNumber] = useState("1");

    const [open, setOpen] = useState(false);
    const [id, setID] = useState("");
    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [OrgName, setOrgName] = useState("");
    const [Dis, setDis] = useState(false);

    const FirstSearch = (e) => {

        if (e?.length > 3) {
            setFirstName(e);
        } else {
            setFirstName(e);
        }
    }
    const LastSearch = (e) => {
        if (e?.length > 3) {
            setLastName(e);
        } else {
            setLastName(e);
        }
    }
    const OrgSearch = (e) => {
        if (e?.length > 3) {
            setOrgName(e);
        } else {
            setOrgName(e);
        }
    }
    const handlePageChange = (event) => {
        setNumber(event);
        setDis(true)
    };

    // const NumberCha = (e) => {
    //     if (FirstName != "" && LastName != "" && OrgName != "") {
    //         setSpinner(!spinner);
    //         axios.get("Login/SearchUsername?FirstName=" + FirstName + "&LastName=" + LastName + "&OrgName=" + OrgName + "&PageNumber=" + e + "&PageSize=10")
    //             .then((res) => {
    //                 setSearchUserNames(res?.data?.data);
    //                 setCount(res?.data?.count);
    //             }).catch(err => {
    //                 console.log(err);
    //             }).finally(() => {
    //                 setSpinner(false);

    //             })
    //     }
    // };
    const handleClickOpen = () => {
        const num = Dis == true ? number : 1
        setNumber(num);
        if (FirstName.trim() != "" && LastName.trim() != "" && OrgName.trim() != "") {
            setSpinner(!spinner);
            axios.get("Login/SearchUsername?FirstName=" + FirstName.trim() + "&LastName=" + LastName.trim() + "&OrgName=" + OrgName.trim() + "&PageNumber=" + num + "&PageSize=10")
                .then((res) => {
                    setSearchUserNames(res?.data?.data);
                    setCount(res?.data?.count);
                }).catch(err => {
                    console.log(err);
                }).finally(() => {
                    setSpinner(false);

                })
        }
    };


    useEffect(() => {
        if (Dis == true) {
            handleClickOpen();
            setDis(false)
        }
    }, [Dis]);

    const [spinner, setSpinner] = React.useState(false);
    const SpinnerClose = () => {
        setSpinner(false);
    };
    const SendRequest = (e) => {
        console.log(e);
        
        const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,20}$/;
        const val = e?.email === ''
            ? (regex.test(e?.userName) ? e?.userName : (regex.test(e?.email) ? e?.email : ''))
            : e?.email;

        setSpinner(!spinner);
        axios.get("Login/CheckUserExist?userName=" + val)
            .then(response => {
                if (response.data.responseCode == 100) {
                    toastNotify(response.data.responseMessage, true);
                } else {
                    toastNotify(response.data.responseMessage, false);
                }
            }).catch((error) => {
                console.log(error.response.data);
            }).finally(() => {
                setSpinner(false)
            });
    }
    // function Details() {
    //     setSpinner(!spinner);
    //     axios.get("Login/SearchUsername?FirstName=" + FirstName + "&LastName=" + LastName + "&OrgName=" + OrgName + "&PageNumber=" + number + "&PageSize=10")
    //         .then((res) => {
    //             setSearchUserNames(res?.data?.data);
    //             setCount(res?.data?.length);
    //         }).catch(err => {
    //             console.log(err);
    //         }).finally(() => {
    //             setSpinner(false);
    //         })
    // }

    const validateEmail = (e) => {
        const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,20}$/;
        return e?.email == '' ? regex.test(e?.userName) : regex.test(e?.email);
    };


    return (
        <div className="first-verify__registerationContainer">
            <Button variant="outlined" className="login-button-backtologin" onClick={() => navigate("/")}>{"<- Back To Login"}</Button>
            <div
                //className="first-verify__inputContainerRegisteration"
                style={{
                    width: "80%",
                    height: "auto",
                    marginLeft: "auto",
                    marginRight: "auto",
                    minHeight: "100px",
                    minWidth: "400px",
                }}>
                <div className="first-verify__logo"></div>
                <h1 className="registerationCompanyHeader">
                    Look Up Trainee Username
                </h1>
                <Card>
                    <ToastContainer />
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={spinner}
                        onClick={SpinnerClose}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Card>
                        {/* <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                            <div style={{ marginLeft: "15px", marginBottom: "15px" }}>

                                <h3> Look Up UserNames</h3>

                            </div>
                        </div>
                        <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} /> */}

                        <div style={{ marginLeft: "15px", marginBottom: "15px", marginTop: "15px" }}>
                            <Stack spacing={2} direction="row">
                                <TextField
                                    placeholder='First Name'
                                    sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                        fontFamily: "Arial, FontAwesome"
                                    }}
                                    variant="outlined"
                                    size="small"
                                    value={FirstName}
                                    onChange={(e) => FirstSearch(e.target.value)}
                                />
                                <TextField
                                    placeholder='Last Name'
                                    sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                        fontFamily: "Arial, FontAwesome"
                                    }}
                                    variant="outlined"
                                    size="small"
                                    value={LastName}
                                    onChange={(e) => LastSearch(e.target.value)}
                                />
                                <TextField
                                    placeholder='Organization Name'
                                    sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                        fontFamily: "Arial, FontAwesome"
                                    }}
                                    variant="outlined"
                                    size="small"
                                    value={OrgName}
                                    onChange={(e) => OrgSearch(e.target.value)}
                                />
                                <Button variant="contained" sx={{ padding: "10px", textTransform: "capitalize" }} disabled={FirstName == "" || LastName == "" || OrgName == ""} onClick={() => handleClickOpen()}>Search</Button>

                            </Stack >

                        </div>

                    </Card>

                    <Box>
                        {SearchUserNames?.length < 1 ?
                            <div hidden={spinner}>
                                <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, width: "auto" }} className="text-center">
                                    <span style={{ color: "#667085" }}>No Result Found</span>
                                </Box>
                            </div> : <>
                                <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                                    <Table aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}>Email / UserName</span></StyledTableCell>
                                                <StyledTableCell >&nbsp;</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        {SearchUserNames?.map((r, i) => (
                                            <TableBody key={i}>

                                                <TableRow key={i} >
                                                    <StyledTableCell sx={{ width: "60%" }} >
                                                        {r?.email == "" ? r?.userName : r?.email}
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ width: "40%" }} >
                                                        {validateEmail(r) ? <>
                                                            <Button variant="contained" sx={{ padding: "inherit", textTransform: "capitalize",width:"max-content" }} onClick={() => SendRequest(r)}>send password reset email</Button>
                                                        </> : <span className='text-danger' style={{ fontSize: "15px", fontWeight: "bold" }}>Contact your company or FV for login assistance</span>}
                                                    </StyledTableCell>

                                                </TableRow>

                                            </TableBody>
                                        ))}
                                    </Table>

                                </TableContainer>
                            </>}

                    </Box >

                </Card>
                <div hidden={SearchUserNames == ""}>
                    <Paginator
                        count={Math.ceil(Count / 10)}
                        page={Number(number)}
                        margin="18px 0px"
                        onChange={handlePageChange}
                    />
                </div>
            </div>
        </div>

    )
}


